import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=5687b8b8&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5687b8b8')) {
      api.createRecord('5687b8b8', component.options)
    } else {
      api.reload('5687b8b8', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=5687b8b8&", function () {
      api.rerender('5687b8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/preferences/IndexPage.vue"
export default component.exports